const env = window.__env__ || {};

export const WEBAPI_URI = env.REACT_APP_WEBAPI_URI || process.env.REACT_APP_WEBAPI_URI;
export const S3_BUCKET = env.REACT_APP_S3_BUCKET || process.env.REACT_APP_S3_BUCKET;
export const GOOGLE_ANALYTICS_TRACKING_ID = env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID || process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
export const RECAPTCHA_KEY = env.REACT_APP_RECAPTCHA_KEY || process.env.REACT_APP_RECAPTCHA_KEY;
